import { render, staticRenderFns } from "./PromoHeader.vue?vue&type=template&id=7c83f14b"
import script from "./PromoHeader.vue?vue&type=script&lang=js"
export * from "./PromoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports